module.exports = __webpack_public_path__ + "static/media/LogosStudyPerth.2911b30c.jpeg";